import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Form, Formik } from 'formik';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Tabs, Tab, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import { MESSAGE_TYPES } from '../../utils';
import { a11yProps, TabPanel } from '../tab/tab';
import GenericDialog from './GenericDialog';
import GMButton from '../button/GMButton';
import FacebookPixelForm from '../form/FacebookPixelForm';
import RecaptchaForm from '../form/RecaptchaForm';
import GoogleAnalyticsForm from '../form/GoogleAnalyticsForm';

const useStyles = makeStyles(() => ({}));

const OtherSettingsDialog = (props) => {
	const { open, handleClose } = props;
	const classes = useStyles();
	const showMessage = useStoreActions((actions) => actions.showMessage.showMessage);
	const [selectedTab, setSelectedTab] = useState(0);
	const [errorMessage, setErrorMessage] = useState(null);
	const saveOtherSettings = useStoreActions((actions) => actions.template.saveOtherSettings);
	const otherSettings = useStoreState((state) => state.template.otherSettings);
	const { facebook_pixel = '', recaptcha = '', google_analytics = '' } = otherSettings;

	const handleChange = (event, newValue) => {
		setSelectedTab(newValue);
	};

	useEffect(() => {
		// console.log('ContactSettings useEffect', contactForm);
		// setContactFormToTemplate(contactForm);
	});

	const onSubmit = async (values, { setSubmitting }) => {
		console.log('OtherSettingsDialog onSubmit', values);
		const responseData = await saveOtherSettings(values);
		if (responseData?.success) {
			showMessage({ text: 'Settings updated', type: MESSAGE_TYPES.SUCCESS });
			handleClose();
		} else {
			setErrorMessage(responseData?.data?.error || 'Error');
		}
		setSubmitting(false);
	};

	const renderForm = (formikBag) => {
		const { isValid, isSubmitting } = formikBag;
		return (
			<Form className={classes.formWrapper}>
				<div className={classes.tabs}>
					<Tabs
						value={selectedTab}
						onChange={handleChange}
						indicatorColor="primary"
						textColor="primary"
						variant="scrollable"
						scrollButtons="auto"
						aria-label="other settings"
					>
						<Tab label="Facebook Pixel" {...a11yProps(0)} />
						<Tab label="Recaptcha" {...a11yProps(1)} />
						<Tab label="Google Analytics" {...a11yProps(2)} />
					</Tabs>
					<TabPanel value={selectedTab} index={0}>
						<FacebookPixelForm errorMessage={errorMessage} />
					</TabPanel>
					<TabPanel value={selectedTab} index={1}>
						<RecaptchaForm errorMessage={errorMessage} />
					</TabPanel>
					<TabPanel value={selectedTab} index={2}>
						<GoogleAnalyticsForm errorMessage={errorMessage} />
					</TabPanel>
				</div>
				<Box
					p={1}
					justifyContent="flex-end"
					alignItems="center"
					flexDirection="row"
					display="flex"
				>
					<GMButton
						variant="contained"
						type="submit"
						disabled={!isValid}
						title={_e('save')}
						color="primary"
						loading={isSubmitting}
					/>
				</Box>
			</Form>
		);
	};

	const initialValues = {
		facebook_pixel,
		recaptcha,
		google_analytics,
	};

	const renderFormikContent = () => {
		return (
			<div>
				<Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
					{renderForm}
				</Formik>
			</div>
		);
	};

	return (
		<GenericDialog
			maxWidth="sm"
			fullWidth
			title={_e('other_settings')}
			// subtitle={<span>Create your own personal branding ebook.</span>}
			content={renderFormikContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

OtherSettingsDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	from: PropTypes.string,
	sectionId: PropTypes.string,
	setFieldValue: PropTypes.func,
};

export default OtherSettingsDialog;
